import React, { useState } from 'react';
import '../UserDetailsForm.css'; // Import the CSS file

const baseURL = process.env.BASE_URL || "";

const UserDetailsForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    phoneNumber: '',
   
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${baseURL}/api/formrouter/visit/shop`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Server Response:', result);
        alert('Form submitted successfully!');

        // Reset the form
        setFormData({
          name: '',
          address: '',
          phoneNumber: '',
          
        });
      } else {
        console.error('Failed to submit form:', response.status);
        alert('Submission failed.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while submitting the form.');
    }
  };

  return (
    <div className="form-container">
      <h2 className='title'>SHOPPING MALL</h2>
      <form onSubmit={handleSubmit} className="user-form">
        <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
        <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
        <input type="tel" name="phoneNumber" placeholder="Phone Number" value={formData.phoneNumber} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default UserDetailsForm;
